var _style, _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgActivity = function SvgActivity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "activity_svg__\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 56 56",
    style: {
      enableBackground: "new 0 0 56 56"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".activity_svg__st2{fill:#172d72}.activity_svg__st3{fill:#be1d32}")), /*#__PURE__*/React.createElement("g", {
    id: "activity_svg__\\u7EC4_5973",
    transform: "translate(-1269 -522)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "activity_svg__\\u7EC4_5972",
    transform: "translate(1269 522)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "activity_svg__\\u77E9\\u5F62_5295",
    style: {
      fill: "none"
    },
    d: "M0 0h56v56H0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "activity_svg__\\u7EC4_5254",
    transform: "translate(1276.875 534.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "activity_svg__\\u77E9\\u5F62_4461",
    style: {
      fill: "#e2e5ee"
    },
    d: "M0 4h40v27.9H0z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "activity_svg__\\u77E9\\u5F62_4462",
    className: "activity_svg__st2",
    d: "M0 0h40v4H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "activity_svg__\\u8DEF\\u5F84_15813",
    className: "activity_svg__st2",
    d: "M40 22.6h-9.4V32l9.4-9.4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "activity_svg__\\u7EC4_5253",
    transform: "translate(5.505 7.565)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "activity_svg__\\u7EC4_5250"
  }, /*#__PURE__*/React.createElement("path", {
    id: "activity_svg__\\u77E9\\u5F62_4463",
    className: "activity_svg__st3",
    d: "M0 0h4.1v4.1H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "activity_svg__\\u77E9\\u5F62_4464",
    className: "activity_svg__st3",
    d: "M8.3 0h4.1v4.1H8.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "activity_svg__\\u77E9\\u5F62_4465",
    className: "activity_svg__st3",
    d: "M16.6 0h4.1v4.1h-4.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "activity_svg__\\u77E9\\u5F62_4466",
    className: "activity_svg__st3",
    d: "M24.8 0h4.1v4.1h-4.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "activity_svg__\\u7EC4_5251",
    transform: "translate(0 16.234)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "activity_svg__\\u77E9\\u5F62_4467",
    className: "activity_svg__st3",
    d: "M0 0h4.1v4.1H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "activity_svg__\\u77E9\\u5F62_4468",
    className: "activity_svg__st3",
    d: "M8.3 0h4.1v4.1H8.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "activity_svg__\\u77E9\\u5F62_4469",
    className: "activity_svg__st3",
    d: "M16.6 0h4.1v4.1h-4.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "activity_svg__\\u7EC4_5252",
    transform: "translate(0 8.118)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "activity_svg__\\u77E9\\u5F62_4470",
    className: "activity_svg__st3",
    d: "M0 0h4.1v4.1H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "activity_svg__\\u77E9\\u5F62_4471",
    className: "activity_svg__st3",
    d: "M8.3 0h4.1v4.1H8.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "activity_svg__\\u77E9\\u5F62_4472",
    className: "activity_svg__st3",
    d: "M16.6 0h4.1v4.1h-4.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "activity_svg__\\u77E9\\u5F62_4473",
    className: "activity_svg__st3",
    d: "M24.8 0h4.1v4.1h-4.1z"
  })))))));
};
export default SvgActivity;